import { combineReducers } from 'redux'
import selected from './get-one'
import last from './get-last'
import all from './get-all'
import newOne from './new'
import editOne from './edit'
import deleteOne from './delete'
import editState from './edit-state'
import addFeedback from './add-feedback'
import editFeedback from './edit-feedback'
import metrics from './get-metrics'
import getCustomerCurrentYear from './get-customer-current-year'

const reducer = combineReducers({
  selected,
  last,
  all,
  newOne,
  editOne,
  editState,
  deleteOne,
  addFeedback,
  editFeedback,
  metrics,
  getCustomerCurrentYear
})

export default reducer
